import React, { useContext } from 'react'

import { DetailItemCardVariant } from './types'

import AssistChip from 'components/Luxkit/Chips/AssistChip'
import LinePaperclipIcon from 'components/Luxkit/Icons/line/LinePaperclipIcon'
import Group from 'components/utils/Group'
import AttachedDocument from 'tripPlanner/components/Documents/AttachedDocument'
import TripItemInlineNoteEdit from 'tripPlanner/components/ItemCard/TripItemInlineNoteEdit'
import { TripDocumentsContext } from 'tripPlanner/contexts/TripDocumentsContext'
import { TripItem } from 'tripPlanner/types/tripItem'

function NotesAndAttachments({
  item,
  canEdit,
  variant,
}: {
  item: TripItem
  canEdit: boolean
  variant: DetailItemCardVariant
}) {
  const documentContext = useContext(TripDocumentsContext)
  const attachedDocuments =
    documentContext?.documentsResult?.attachedFiles[item.id] ?? []

  return (
    <>
      {attachedDocuments.map((document) => (
        <AttachedDocument key={document.filename} document={document} />
      ))}
      <Group
        direction="horizontal"
        wrap="wrap-reverse"
        gap="12 8"
        noDisplayWhenEmpty
      >
        {variant !== 'drawer' && <TripItemInlineNoteEdit item={item} />}
        {documentContext && canEdit && (
          <AssistChip
            size="small"
            onClick={() => documentContext.onRequestAddDocument(item.id)}
            variant="filled"
            startIcon={<LinePaperclipIcon />}
          >
            Attach document
          </AssistChip>
        )}
      </Group>
    </>
  )
}

export default NotesAndAttachments
